import { createFileRoute } from "@tanstack/react-router";
import { cityHead } from "../lib/route-head";
import { CityPage } from "../components/city-page";


export const Route = createFileRoute("/pressure-washing-bethlehem-ny")({
  loader: async () => (await import("../data/cities")).getCity("pressure-washing-bethlehem-ny")!,
  head: ({ loaderData }) => cityHead("pressure-washing-bethlehem-ny", loaderData),
  component: RouteComponent,
});

function RouteComponent() {
  const content = Route.useLoaderData();
  return <CityPage content={content} />;
}
